import { Page } from '@/core/architecture'

import { ConsoleItemOrdersTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleItemOrders Page
 * Implemented as a practical sample.
 */
export const ConsoleItemOrders: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleItemOrdersTemplate state={state} {...actions} />
}
